import http from '../../plugins/axios';

export default {

    create(data){
        return http.post({
            url: '/admin/activity/match/create',
            data
        })
    },

    detail(data){
        return http.get({
            url: '/admin/activity/match/detail',
            data
        })
    },

    list(data){
        return http.get({
            url: '/admin/activity/match/list',
            data
        })
    },

    auditList(data) {
        return http.get({
            url: '/admin/combat/team/list',
            data
        })
    },

    auditStatus(data) {
        return http.get({
            url: '/admin/combat/team/audit',
            data
        })
    },

    updateMatch(data) {
        return http.post({
            url: '/admin/activity/match/update',
            data
        })
    }
}